// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","moreResults":"_3rgYRLqgw83Y-JiE6xE9d6"};